/*
A BACK HI HA LA MATEIXA ENUM AMB EQUIVALENCIA DE fitlerKey
*/
export enum BookingFilterTypes {

    NoFiltersTypes = 'ROUTE.FILTER.NOFILTERSTYPES',

	Conflictive = 'BOOKING.FILTER.CONFLICTIVE',

	Incompleted = 'BOOKING.FILTER.INCOMPLETED',

	WithOutAllRoute = 'BOOKING.FILTER.WITHOUTALLROUTE',

	WithOutAllLoaded = 'BOOKING.FILTER.WITHOUTALLLOADED',

	None = 'NONE'
    
}